<template lang="pug">
.login
</template>
<script>
import api from '@/apis/commuCore'

export default {
  name: 'login',
  data () {
    return {}
  },
  async mounted () {
    await api.Logout()
    api.showLoginModal()
  }
}
</script>
